/*
  AJUSTEMENTS SAWAFOOTBALL (fiche produit)
  1. Mobile : reduit l'espace vide entre le prix et la suite (guide des tailles, choix de la taille...).
     Sous le prix, le theme garde des blocs sans contenu visible (paiement en plusieurs fois non
     disponible, emplacement de l'appli Kiwi...) qui ajoutent chacun de l'espace vide, et le bloc prix
     a lui-meme de l'espace sous le texte. Ce script mesure l'ecart VISIBLE entre le bas du texte du prix
     et le haut du premier texte/element visible en dessous, et le ramene a ESPACE pixels.
  2. Ramene l'espace entre le bloc au-dessus du bouton « Ajouter au panier » (offre -30 %) et le bouton
     a ESPACE_BOUTON pixels (mobile et ordinateur), mesure du bas du cadre de l'offre au haut du bouton.
  3. Ordinateur (1000 px et plus) : ecarts du haut de la fiche aux proportions de Comma (RYTHME_ORDI),
     prix -> Modele et Modele -> Taille resserres.
  4. Mobile : meme travail (RYTHME_MOBILE) + espace entre les miniatures des photos et le debut des infos
     ramene a GALERIE_MOBILE pixels, pour que le bouton « Ajouter au panier » remonte.
     Ecart mesure de la ligne de base du texte du dessus (ou du bas d'une image) jusqu'au haut des
     majuscules du texte du dessous (ou du haut d'une image), comme on le voit a l'ecran.
  5. Bloc de l'offre « 2 maillots = -30 % » (appli Sternify) : repere par son texte et marque de la classe
     sawa-offre, qui le rend un peu plus petit (voir assets/carrousel-mobile.css).
  Les blocs de la fiche sont empiles avec des marges qui FUSIONNENT (la plus grande l'emporte, et les blocs
  vides laissent passer les leurs) : setGap() met a zero la marge du bloc du dessus et celles des blocs vides
  entre les deux, puis regle la marge du haut du bloc du dessous (negative si besoin) et verifie le resultat.
  Tout se relance quand la fiche est redessinee (changement de taille) ou quand une appli ajoute son contenu.
*/
(function () {
  if (window.sawaPriceSpacing) return;
  window.sawaPriceSpacing = true;

  var ESPACE = 10; /* espace voulu (en px) entre le prix et le contenu suivant, sur mobile */
  var ESPACE_BOUTON = 6; /* espace voulu (en px) entre l'offre au-dessus et le bouton « Ajouter au panier » (ordinateur) */
  var ESPACE_BOUTON_MOBILE = 14; /* meme espace, sur mobile */
  /* Ordinateur : [bloc du dessus, bloc du dessous, ecart voulu en px] ('*' = n'importe quel bloc).
     Valeurs mesurees sur la fiche produit de Comma. */
  var RYTHME_ORDI = [
    ['*', 'title', 14],           /* note (etoiles) -> titre */
    ['title', '*', 21],           /* titre -> phrase sous le titre */
    ['vendor', '*', 23],          /* phrase sous le titre -> prix */
    ['price', '*', 16],           /* prix -> Modele (ou Taille) */
    ['autres-modeles', 'variant-picker', 14]   /* vignettes Modele -> Taille */
  ];
  /* Mobile (moins de 700 px) : meme principe ; l'ecart prix -> Modele reste regle par ESPACE */
  var RYTHME_MOBILE = [
    ['*', 'title', 10],           /* note (etoiles) -> titre */
    ['title', '*', 14],           /* titre -> phrase sous le titre */
    ['vendor', '*', 16],          /* phrase sous le titre -> prix */
    ['autres-modeles', 'variant-picker', 12],  /* vignettes Modele -> Taille */
    ['liquid', '@app', 34]        /* barre « Taille petit / normalement / grand » -> offre -30 % */
  ];
  var GALERIE_MOBILE = 16; /* espace (en px) entre le bas des miniatures des photos et la note, sur mobile */
  var mobile = window.matchMedia('(max-width: 699px)');
  var ordi = window.matchMedia('(min-width: 1000px)');
  var scheduled = false;
  var MEDIA = /^(img|svg|video|canvas|iframe|select|textarea|button|picture)$/i;
  /* .sawa-modele__nom : bulle du nom de l'edition (Modele), qui passe par-dessus la suite : jamais comptee */
  var HIDDEN = '.sr-only, .visually-hidden, [hidden], template, script, style, noscript, .sawa-modele__nom';

  function shown(el) {
    if (el.closest(HIDDEN)) return false;
    var cs = window.getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) return false;
    var r = el.getBoundingClientRect();
    return r.width > 1 && r.height > 1;
  }

  /* Un element fixe a l'ecran (fenetre, bulle...) ou qui sort du bloc ne compte pas dans les mesures */
  function floating(el, root) {
    for (var node = el; node && node !== root; node = node.parentElement) {
      if (window.getComputedStyle(node).position === 'fixed') return true;
    }
    return false;
  }

  function inside(rect, box) {
    return rect.bottom > box.top + 0.5 && rect.top < box.bottom - 0.5;
  }

  /* Rectangles de tout le contenu visible (texte, images, boutons...) d'un bloc */
  function contentRects(root) {
    var out = [];
    var box = root.getBoundingClientRect();
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (node.nodeType === 3) {
        if (!node.nodeValue.trim() || !node.parentElement || !shown(node.parentElement) || floating(node.parentElement, root)) continue;
        var range = document.createRange();
        range.selectNodeContents(node);
        var rects = range.getClientRects();
        for (var k = 0; k < rects.length; k++) {
          if (rects[k].height > 0 && rects[k].width > 0 && inside(rects[k], box)) out.push(rects[k]);
        }
      } else if ((MEDIA.test(node.tagName) || node.shadowRoot) && shown(node) && !floating(node, root)) {
        var mr = node.getBoundingClientRect();
        if (inside(mr, box)) out.push(mr);
      }
    }
    return out;
  }

  function contentTop(root) {
    return contentRects(root).reduce(function (v, r) { return Math.min(v, r.top); }, Infinity);
  }

  function contentBottom(root) {
    return contentRects(root).reduce(function (v, r) { return Math.max(v, r.bottom); }, -Infinity);
  }

  function transparent(color) {
    return !color || color === 'transparent' || /^rgba\(.*,\s*0\)$/.test(color);
  }

  /* un fond blanc (ou presque) ne se voit pas sur la page blanche : il ne compte pas comme un bord visible */
  function invisibleBackground(color) {
    if (transparent(color)) return true;
    var m = color.match(/\d+(\.\d+)?/g);
    return !!m && m.length >= 3 && +m[0] >= 250 && +m[1] >= 250 && +m[2] >= 250;
  }

  /* Comme contentRects, mais compte aussi les cadres et les fonds (bordure de l'offre, fond du bouton) */
  function visualRects(root) {
    var out = contentRects(root);
    root.querySelectorAll('*').forEach(function (el) {
      if (!shown(el)) return;
      var cs = window.getComputedStyle(el);
      var border = ['Top', 'Bottom', 'Left', 'Right'].some(function (side) {
        return parseFloat(cs['border' + side + 'Width']) > 0 && cs['border' + side + 'Style'] !== 'none' && !transparent(cs['border' + side + 'Color']);
      });
      var background = !invisibleBackground(cs.backgroundColor) || cs.backgroundImage !== 'none';
      if (border || background) out.push(el.getBoundingClientRect());
    });
    return out;
  }

  function visualTop(root) {
    return visualRects(root).reduce(function (v, r) { return Math.min(v, r.top); }, Infinity);
  }

  function visualBottom(root) {
    return visualRects(root).reduce(function (v, r) { return Math.max(v, r.bottom); }, -Infinity);
  }

  /* --- Mesure comme a l'ecran : ligne de base et haut des majuscules (point 3) --- */
  var metricsCache = {};
  var probe = null;

  function fontMetrics(el) {
    var cs = window.getComputedStyle(el);
    var font = cs.fontStyle + ' ' + cs.fontWeight + ' ' + cs.fontSize + ' ' + cs.fontFamily;
    if (metricsCache[font]) return metricsCache[font];
    var size = parseFloat(cs.fontSize) || 16;
    var res = { cap: size * 0.7, descent: size * 0.22 };
    try {
      if (!probe) probe = document.createElement('canvas').getContext('2d');
      probe.font = font;
      var m = probe.measureText('H');
      if (m.actualBoundingBoxAscent) res.cap = m.actualBoundingBoxAscent;
      if (typeof m.fontBoundingBoxDescent === 'number') res.descent = m.fontBoundingBoxDescent;
    } catch (e) {}
    metricsCache[font] = res;
    return res;
  }

  function inkRects(root) {
    var out = [];
    var box = root.getBoundingClientRect();
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (node.nodeType === 3) {
        var parent = node.parentElement;
        if (!node.nodeValue.trim() || !parent || !shown(parent) || floating(parent, root)) continue;
        var fm = fontMetrics(parent);
        var range = document.createRange();
        range.selectNodeContents(node);
        var rects = range.getClientRects();
        for (var k = 0; k < rects.length; k++) {
          if (rects[k].height > 0 && rects[k].width > 0 && inside(rects[k], box)) {
            var base = rects[k].bottom - fm.descent;
            out.push({ top: base - fm.cap, bottom: base });
          }
        }
      } else if ((MEDIA.test(node.tagName) || node.shadowRoot) && shown(node) && !floating(node, root)) {
        var r = node.getBoundingClientRect();
        if (inside(r, box)) out.push({ top: r.top, bottom: r.bottom });
      }
    }
    return out;
  }

  function inkTop(root) {
    return inkRects(root).reduce(function (v, r) { return Math.min(v, r.top); }, Infinity);
  }

  function inkBottom(root) {
    return inkRects(root).reduce(function (v, r) { return Math.max(v, r.bottom); }, -Infinity);
  }

  function blockType(el) {
    return el.getAttribute('data-block-type') || '';
  }

  /* Ecart visible entre deux blocs = want (measure() renvoie l'ecart actuel). Voir l'explication en haut. */
  function setGap(items, up, low, want, measure) {
    var from = items.indexOf(up), to = items.indexOf(low);
    if (from === -1 || to === -1 || to <= from) return;
    for (var b = from + 1; b < to; b++) {
      var el = items[b];
      if (window.getComputedStyle(el).display === 'none') continue;
      el.style.marginTop = '0px';
      el.style.marginBottom = '0px';
      el.dataset.sawaPull = '1';
    }
    up.style.marginBottom = '0px';
    up.dataset.sawaPull = '1';
    low.style.marginTop = '0px';
    low.dataset.sawaPull = '1';
    for (var i = 0; i < 3; i++) {
      var gap = measure();
      if (!isFinite(gap)) return;
      var diff = gap - want;
      if (Math.abs(diff) <= 0.5) return;
      low.style.marginTop = ((parseFloat(low.style.marginTop) || 0) - diff) + 'px';
    }
  }

  function wantedGap(up, low, rules) {
    for (var i = 0; i < rules.length; i++) {
      var r = rules[i];
      if ((r[0] === '*' || r[0] === blockType(up)) && (r[1] === '*' || r[1] === blockType(low))) return r[2];
    }
    return null;
  }

  /* 3. Chaque paire de blocs visibles consecutifs prevue dans les regles est mise a l'ecart voulu (setGap) */
  function explicitTarget(up, visibles, k, rules) {
    for (var i = 0; i < rules.length; i++) {
      var r = rules[i];
      if (r[1] === '*' || (r[0] !== '*' && r[0] !== blockType(up))) continue;
      for (var j = k + 1; j < visibles.length; j++) {
        if (blockType(visibles[j]) === r[1]) return { low: visibles[j], want: r[2] };
      }
    }
    return null;
  }

  function rythme(items, rules) {
    var visibles = items.filter(function (el) { return inkTop(el) !== Infinity; });
    for (var k = 0; k + 1 < visibles.length; k++) {
      var up = visibles[k];
      var low = visibles[k + 1];
      var want = null;
      /* regle qui vise un bloc precis (ex. vignettes Modele -> Taille) : on le cherche plus bas,
         meme si un bloc d'appli (Kiwi...) s'intercale */
      var target = explicitTarget(up, visibles, k, rules);
      if (target) {
        low = target.low;
        want = target.want;
      } else {
        want = wantedGap(up, low, rules);
      }
      if (blockType(low) === 'buy-buttons') continue; /* deja regle par ESPACE_BOUTON */
      if (want === null) continue;
      (function (u, l) {
        setGap(items, u, l, want, function () { return inkTop(l) - inkBottom(u); });
      })(up, low);
    }
  }

  function adjust() {
    scheduled = false;
    metricsCache = {};

    document.querySelectorAll('.product-info').forEach(function (info) {
      var items = Array.prototype.slice.call(info.children);

      /* 5. bloc de l'offre -30 % : marque pour etre affiche plus petit */
      items.forEach(function (el) {
        if (el.classList.contains('sawa-offre')) return;
        var text = el.textContent || '';
        if (blockType(el) === '@app' && /OFFRE/i.test(text) && /30\s*%/.test(text)) el.classList.add('sawa-offre');
      });

      if (info.dataset.sawaTop) {
        info.style.marginTop = '';
        delete info.dataset.sawaTop;
      }

      items.forEach(function (el) {
        if (el.dataset.sawaPull) {
          el.style.marginTop = '';
          el.style.marginBottom = '';
          delete el.dataset.sawaPull;
        }
        if (el.dataset.sawaHidden) {
          el.style.display = '';
          delete el.dataset.sawaHidden;
        }
        if (el.dataset.sawaAtcGap) {
          el.style.marginTop = '';
          delete el.dataset.sawaAtcGap;
        }
      });

      /* 2. ESPACE_BOUTON px entre le bloc visible au-dessus (offre -30 %) et le bouton « Ajouter au panier »
         (mobile et ordinateur) : du bas du cadre de l'offre au haut du bouton */
      items.forEach(function (el, index) {
        if (!el.matches('[data-block-type="buy-buttons"]')) return;
        if (visualTop(el) === Infinity) return;
        for (var j = index - 1; j >= 0; j--) {
          if (visualBottom(items[j]) === -Infinity) continue;
          var above = items[j];
          setGap(items, above, el, mobile.matches ? ESPACE_BOUTON_MOBILE : ESPACE_BOUTON, function () { return visualTop(el) - visualBottom(above); });
          return;
        }
      });

      if (ordi.matches) {
        rythme(items, RYTHME_ORDI);
        return;
      }

      if (!mobile.matches) return;

      rythme(items, RYTHME_MOBILE);

      /* 4. Mobile : espace entre le bas des miniatures des photos et le debut des infos */
      var gallery = info.parentElement ? info.parentElement.querySelector(':scope > .product-gallery') : null;
      if (gallery && shown(gallery)) {
        var firstTop = Infinity;
        for (var f = 0; f < items.length && firstTop === Infinity; f++) firstTop = inkTop(items[f]);
        var galleryBottom = gallery.getBoundingClientRect().bottom;
        if (firstTop !== Infinity && firstTop > galleryBottom) {
          var galleryDiff = firstTop - galleryBottom - GALERIE_MOBILE;
          if (Math.abs(galleryDiff) > 0.5) {
            var infoMargin = parseFloat(window.getComputedStyle(info).marginTop) || 0;
            info.style.marginTop = (infoMargin - galleryDiff) + 'px';
            info.dataset.sawaTop = '1';
          }
        }
      }

      var price = null;
      items.forEach(function (el) {
        if (!price && el.matches('[data-block-type="price"]')) price = el;
      });
      if (!price) return;

      if (contentBottom(price) === -Infinity) return;

      /* premier bloc sous le prix qui a vraiment du contenu visible (les blocs vides entre les deux
         sont neutralises par setGap) */
      var target = null;
      for (var i = items.indexOf(price) + 1; i < items.length; i++) {
        if (contentTop(items[i]) !== Infinity) {
          target = items[i];
          break;
        }
      }
      if (!target) return;
      setGap(items, price, target, ESPACE, function () { return contentTop(target) - contentBottom(price); });
    });
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(adjust);
  }

  function watch() {
    var observer = new MutationObserver(schedule);
    document.querySelectorAll('product-rerender, .product-info').forEach(function (host) {
      observer.observe(host, { childList: true, subtree: true });
    });
    schedule();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }

  window.addEventListener('load', schedule);
  window.addEventListener('resize', schedule);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
  if (mobile.addEventListener) mobile.addEventListener('change', schedule);
  if (ordi.addEventListener) ordi.addEventListener('change', schedule);
  /* filet de securite : les applis (Kiwi...) chargent parfois leur contenu en retard */
  [500, 1500, 3000].forEach(function (t) { window.setTimeout(schedule, t); });
})();

/*
  6. Achat rapide (bouton « + Ajouter » des collections) : garde le lien « Guide des tailles » de l'appli Kiwi
     quand le client choisit une taille. Le theme redessine le contenu de l'achat rapide a chaque changement de
     taille, ce qui efface le lien ajoute par Kiwi : on le memorise et on le remet juste avant le choix de la taille.
     Si Kiwi remet son lien lui-meme, la copie remise ici est retiree (pas de doublon).
*/
(function () {
  if (window.sawaKiwiQuickBuy) return;
  window.sawaKiwiQuickBuy = true;

  var KIWI = '.ks-chart-container';
  var BOXES = 'quick-buy-drawer, quick-buy-modal';
  var saved = new WeakMap();
  var restored = new WeakMap();
  var queued = false;

  function isKiwiWrapper(el) {
    if (!el || el === document.body) return false;
    if (el.classList.contains('shopify-app-block')) return false;
    if (el.id && el.id.indexOf('shopify-block') === 0) return false;
    var cls = typeof el.className === 'string' ? el.className : '';
    return /(^|\s)(ks-|kiwi)/i.test(cls + ' ' + (el.id || ''));
  }

  function kiwiTops(box) {
    var tops = [];
    Array.prototype.forEach.call(box.querySelectorAll(KIWI), function (link) {
      var top = link;
      while (top.parentElement && top.parentElement !== box && isKiwiWrapper(top.parentElement)) top = top.parentElement;
      if (tops.indexOf(top) === -1) tops.push(top);
    });
    return tops;
  }

  function check() {
    queued = false;
    Array.prototype.forEach.call(document.querySelectorAll(BOXES), function (box) {
      var tops = kiwiTops(box);
      var mine = restored.get(box) || [];
      if (mine.length && tops.length > mine.length) {
        mine.forEach(function (node) { node.remove(); });
        restored.set(box, []);
        tops = kiwiTops(box);
      }
      if (tops.length) {
        saved.set(box, tops);
        return;
      }
      var keep = saved.get(box);
      var picker = box.querySelector('variant-picker, .variant-picker');
      if (!keep || !keep.length || !picker || !picker.parentNode) return;
      keep.forEach(function (node) { picker.parentNode.insertBefore(node, picker); });
      restored.set(box, keep.slice());
    });
  }

  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(check);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
